import axios from "axios";
import { useContext } from "react";
import alertIcon from "../../../assets/images/alert.svg";
import Context from "../../../context";
import { API_URL } from "../../data/constants";

export const RemovePaymentTitle = () => {
  return (
    <>
      <div className="modal-header__icon-wrapper">
        <img className="modal-header-icon" alt="alert" src={alertIcon} /> Remove
        Payment Method
      </div>
    </>
  );
};

export const RemovePaymentContent = () => {
  const { contextState, setContextState } = useContext(Context);
  const payload = contextState.modal?.payload;

  return (
    <>
      <p className="text-center">
        Are you sure you want to remove this payment method? This cannot be
        undone.
      </p>
      <div className="row justify-content-center">
        <div className="col-12 col-sm-auto">
          <button
            className="btn-sm-fluid btn--blue btn--bordered mb-2 mb-sm-0"
            onClick={() =>
              setContextState((prevState) => ({ ...prevState, modal: null }))
            }>
            No, Cancel
          </button>
        </div>
        <div className="col-12 col-sm-auto">
          <button
            className="btn-sm-fluid btn--red btn--bordered"
            onClick={() => {
              axios
                .delete(API_URL + "/Payments/Profile", {
                  headers: {
                    Authorization: `${localStorage.getItem("accessToken")}`,
                    "Content-Type": "application/json; charset=utf-8",
                  },
                  data: payload[0],
                })
                .then((res) => {})
                .catch((err) => {
                  console.error(err);
                });
              setContextState((prevState) => ({
                ...prevState,
                paymentMethodsChanged: true,
                modal: null,
              }));
            }}>
            Yes, Remove
          </button>
        </div>
      </div>
    </>
  );
};
